import PropTypes from 'prop-types';
import {Questionnaire} from "../../qnr";
import {Divider, Typography} from "@material-ui/core";
import Box from "../Box";
import UserEvent from "../../core/UserEvent";
import React, {useEffect} from "react";
import Section from "./Section";
import lang from "../../core/lang";
import logger from "../../core/logger";

const log = logger.getLogger('appfuse.component.Survey');

function Survey(props) {
    const {activeSection, compact, fullHeight, fullWidth, overflow, readOnly, disabled, validation, disabledColor, diff, showUndo, variant, changeIndicator, tailIndicatorRenderer} = props;
    const value = Questionnaire.of(props.value);
    const change = Questionnaire.of(props.change);
    const questionnaire = change ? change : value;
    const title = questionnaire?.title;

    log.debug('Rendering......');

    useEffect(() => {
        log.debug('Mounted.');
        return () => {
            log.debug('Unmounted.');
        }
    }, [])

    const handleChange = event => {
        const { section, question } = event;
        const newQuestionnaire = questionnaire.clone();
        newQuestionnaire.setSection(activeSection, section);
        props.onChange && props.onChange(new UserEvent({
            value: newQuestionnaire,
            change: newQuestionnaire,
            questionnaire: newQuestionnaire,
            section, question
        }));
    }

    let sectionNodes;
    if(lang.isNotNullOrUndefined(activeSection)) {
        const section = value.getSection(activeSection);
        const sectionChange = change?.getSection(activeSection);
        sectionNodes = <Section value={section} change={sectionChange} diff={diff} showUndo={showUndo} variant={variant} onChange={handleChange} index={activeSection} compact={compact} readOnly={readOnly} disabled={disabled} validation={validation} disabledColor={disabledColor} changeIndicator={changeIndicator} tailIndicatorRenderer={tailIndicatorRenderer}/>
    } else {
        sectionNodes = value.sections.map((section, index, sections) => {
            const sectionChange = change?.sections[index];
            return (
              <div key={index}>
                <Section
                  value={section}
                  change={sectionChange}
                  diff={diff}
                  showUndo={showUndo}
                  variant={variant}
                  onChange={handleChange}
                  index={index}
                  readOnly={readOnly}
                  disabled={disabled}
                  disabledColor={disabledColor}
                  changeIndicator={changeIndicator}
                  tailIndicatorRenderer={tailIndicatorRenderer}
                />
                {index < sections.length ? (
                  <Box paddingY={1} marginBottom={1}>
                    <Divider />
                  </Box>
                ) : null}
              </div>
            );
        });
    }

    log.debug('Rendered.');

    return (
        <Box fullHeight={fullHeight} fullWidth={fullWidth} overflow={overflow}>
            {compact ? null : <Typography variant="h5" align="center">{title}</Typography>}
            {sectionNodes}
        </Box>
    )
}


Survey.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.instanceOf(Questionnaire)
    ]),
    change: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.instanceOf(Questionnaire)
    ]),
    activeSection: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    onChange: PropTypes.func,
    compact: PropTypes.bool,
    fullHeight: PropTypes.bool,
    fullWidth: PropTypes.bool,
    overflow: PropTypes.string,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    // 是否檢視檢核結果
    validation: PropTypes.bool,
    disabledColor: PropTypes.string,
    // 標示變更的差異
    diff: PropTypes.bool,
    showUndo: PropTypes.bool,
    variant: PropTypes.oneOf(['legacy', 'classic']),
    changeIndicator: PropTypes.func,
    tailIndicatorRenderer: PropTypes.func,
}

Survey.defaultProps = {
    variant: 'classic',
    showUndo: true
}

export default Survey;